import React from 'react'
import { WMSTileLayer, MapContainer, TileLayer, LayerGroup, Map, LayersControl, ZoomControl } from 'react-leaflet';
const { BaseLayer } = LayersControl;

export default function BaseLayersComponent() {
  return (
    <>
      <BaseLayer checked={true} name={'Openstreet'}>
        <TileLayer
          attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a>'
          url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
        />
      </BaseLayer>
    </>
  )
}
